<template>
	<span v-if="showNav">
		<a
			:aria-expanded="eSimCollapse"
			class="sidebar-menu-item nav-link"
			data-toggle="collapse"
			@click="eSimCollapse = !eSimCollapse"
			id="nav-esim-collapse"
		>
			<template>
				<i class="fa pr-2 fa-sim-card text-green"></i>
				<span class="nav-link-text">eSIM <b class="caret"></b></span>
			</template>
		</a>
		<collapse-transition :duration="{enter: 500, leave: 500}">
			<div v-show="eSimCollapse" id="collapse-just2" :class="eSimCollapse ? 'show' : ''" class="collapse">
				<ul class="nav nav-sm flex-column">
					<slot name="title">
						<router-link
              id="nav-esim-inventory"
							v-if="navPermissions['inventory'].enable"
							:target="link.target"
							class="nav-link"
							href="/esim/inventory"
							to="/esim/inventory"
							@click.native="linkClick"
						>
							<template>
								<i class="fa fa-folder-open text-green pr-2"></i>
								<span class="nav-link-text">Inventory</span>
							</template>
						</router-link>
						<router-link
							v-if="navPermissions['profile'].enable"
							:target="link.target"
							class="nav-link"
							href="/esim/profile/:iccid="
							to="/esim/profile/:iccid="
							id="nav-esim-profile"
							@click.native="linkClick"
						>
							<template>
								<i class="fa fa-info text-yellow pr-2"></i>
								<span class="nav-link-text">Profile</span>
							</template>
						</router-link>
						<!-- <router-link
							v-if="navPermissions['order'].enable"
							:target="link.target"
							class="nav-link"
							href="/esim/order"
							to="/esim/order"
							@click.native="linkClick"
						>
							<template>
								<i class="fa fa-cart-arrow-down text-teal pr-2"></i>
								<span class="nav-link-text">Order</span>
							</template>
						</router-link> -->

						<router-link
              id="nav-esim-report"
							v-if="navPermissions['report'].enable"
							:target="link.target"
							class="nav-link"
							href="/esim/report"
							to="/esim/report"
							@click.native="linkClick"
						>
							<template>
								<i class="fa mr-2 fa-file-invoice text-danger pr-2"></i>
								<span class="nav-link-text">Report</span>
							</template>
						</router-link>

						<router-link
              id="nav-esim-qrcode"
							v-if="navPermissions['qrcode'].enable"
							:target="link.target"
							class="nav-link"
							href="/esim/qrcode/:iccid="
							to="/esim/qrcode/:iccid="
							@click.native="linkClick"
						>
							<template>
								<i class="fa fa-qrcode text-orange pr-2"></i>
								<span class="nav-link-text">QrCode</span>
							</template>
						</router-link>
						<router-link
              id="nav-esim-import"
							v-if="isPortalAdminStatus"
							:target="link.target"
							class="nav-link"
							href="/esim/import"
							to="/esim/import"
							@click.native="linkClick"
						>
							<template>
								<i class="fa fa-upload text-red pr-2"></i>
								<span class="nav-link-text">Import</span>
								&nbsp; <i class="fa fa-lock text-gray size-32"></i>
							</template>
						</router-link>
						<router-link
              id="nav-esim-carrier"
							v-if="isPortalAdminStatus"
							:target="link.target"
							class="nav-link"
							href="/esim/carrier_admin"
							to="/esim/carrier_admin"
							@click.native="linkClick"
						>
							<template>
								<i class="fa fa-wrench text-indigo pr-2"></i>
								<span class="nav-link-text">Carrier</span>
								&nbsp; <i class="fa fa-lock text-gray size-32"></i>
							</template>
						</router-link>
					</slot>
				</ul>
			</div>
		</collapse-transition>
	</span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";
import initService from "../../../common/api-services/init-service";

export default {
	name: "side-e-sim-group",
	components: {
		CollapseTransition,
	},
	data() {
		return {
			isPortalAdminStatus: false,
			isAdminStatus: false,
			groups: [],
			showNav: false,

			eSimCollapse: false,
			link: {
				name: "",
				icon: "",
				path: "",
				children: [],
			},

			navPermissions: {
				inventory: {
					enable: false,
					role: ["ESIM_ADMIN", "ESIM_EDIT", "ESIM_READ", "Administrator"],
				},
				profile: {
					enable: false,
					role: ["ESIM_ADMIN", "ESIM_EDIT", "ESIM_READ", "Administrator"],
				},
				// order: {
				// 	enable: false,
				// 	role: ["ESIM_ADMIN", "ESIM_EDIT", "Administrator"],
				// },
				report: {
					enable: false,
					role: ["ESIM_ADMIN", "Administrator"],
				},
				qrcode: {
					enable: false,
					role: ["ESIM_ADMIN", "ESIM_EDIT", "ESIM_READ", "Administrator"],
				},
				import: {
					enable: false,
					role: ["PORTAL_ADMIN"],
				},
				carrier: {
					enable: false,
					role: ["PORTAL_ADMIN"],
				},
				help: {
					enable: false,
					role: ["ESIM_ADMIN", "ESIM_EDIT", "ESIM_READ", "Administrator"],
				},
			},
		};
	},
	mounted() {
		this.isPortalAdminStatus = initService.getPortalAdminRole();
		this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
		this.groups = initService.getGroups();
		Object.keys(this.navPermissions).map(item => {
			this.groups.map(it => {
				if (this.navPermissions[item].role.includes(it)) {
					this.navPermissions[item].enable = true;
					this.showNav = true;
				}
			});
		});
	},
	methods: {
		linkClick() {
			if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
				this.$sidebar.displaySidebar(false);
			}
		},
	},
};
</script>
